import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Path 2623",
  "use": "icon-Path 2623-usage",
  "viewBox": "0 0 74.889 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 74.889 20\" id=\"icon-Path 2623\">\n  <path id=\"icon-Path 2623_Path_2623\" data-name=\"Path 2623\" d=\"M434.333-44H368V-64h66.333l8.556,10Z\" transform=\"translate(-368 64)\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Path 2623.svg
// module id = G+KB
// module chunks = 3